import classNames from 'classnames';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from '../Button';

interface AdSpend {
  title: string;
  hsID: string;
}
[];

interface AdSpendInputProps {
  inputError: boolean;
  setAdSpend?: React.Dispatch<React.SetStateAction<AdSpend>>;
  adSpend?: AdSpend;
}

const AdSpendInput: React.FC<AdSpendInputProps> = props => {
  const { adSpend, inputError, setAdSpend } = props;
  const { t } = useTranslation();

  const [adSpendFilterOpen, setAdSpendFilterOpen] = useState<boolean>(false);
  const [AdSpendChild, setAdSpendChild] = useState<boolean>(false);

  const adSpendList = t('adSpendTiers', { returnObjects: true });

  return (
    <div className="w-full">
      <Button
        onClick={() => {
          setAdSpendFilterOpen(!adSpendFilterOpen);
        }}
        className={classNames(
          'bg-white border flex justify-between rounded-lg border-gray-3-light hover:border-gray-1 focus:border-indigo-1 focus:outline-none focus:ring-4 focus:ring-indigo-3-light placeholder-gray-3 px-4 py-3  transition-colors w-full h-10',
          inputError && adSpend?.title == '' && 'input-error'
        )}
      >
        <div className="font-medium">
          <span className="text-gray-3 mr-4">{t('$')}</span>
          {adSpend && adSpend?.title !== '' ? (
            <span>{adSpend?.title}</span>
          ) : (
            <span className="text-gray-3">
              <Trans i18nKey="select">- Select -</Trans>
            </span>
          )}
        </div>
        <svg
          width="6"
          height="12"
          viewBox="0 0 6 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.60371 0.514705C2.80386 0.254701 3.19597 0.254701 3.39612 0.514705L5.84433 3.69503C6.09743 4.02381 5.86304 4.50002 5.44813 4.50002H0.551702C0.136782 4.50002 -0.0975992 4.02381 0.155499 3.69503L2.60371 0.514705Z"
            fill="#9CA3AF"
          />
          <path
            d="M2.60371 11.4853C2.80386 11.7453 3.19597 11.7453 3.39612 11.4853L5.84433 8.30502C6.09743 7.97623 5.86304 7.50002 5.44813 7.50002H0.551702C0.136782 7.50002 -0.0975992 7.97623 0.155499 8.30502L2.60371 11.4853Z"
            fill="#9CA3AF"
          />
        </svg>

        {adSpendFilterOpen === true && (
          <ul className="z-10 absolute top-full mt-1 py-2 left-0 bg-white w-full rounded-md shadow-2xl">
            {adSpendList &&
              adSpendList?.map((key, index) => (
                <>
                  <li
                    key={index}
                    onClick={e => {
                      if (key?.subAdSpend) {
                        e.stopPropagation();
                        setAdSpendChild(true);
                      } else {
                        setAdSpend({ title: key.title, hsID: key.hsID });
                      }
                    }}
                    className="w-full flex items-center justify-between realative text-left px-6 py-2 text-base hover:bg-gray-5-light"
                  >
                    {key.title}
                    {index == 0 && (
                      <svg
                        className="ml-1 fill-current w-2"
                        width="11"
                        height="16"
                        viewBox="0 0 11 16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.11567 10.5391C5.31557 10.7789 5.68399 10.7789 5.88389 10.5391L9.81637 5.82009C10.0878 5.49442 9.85618 5 9.43226 5H1.5673C1.14338 5 0.911804 5.49442 1.18319 5.82009L5.11567 10.5391Z"
                        />
                      </svg>
                    )}
                  </li>
                  {key?.subAdSpend && AdSpendChild && (
                    <ul className="z-10 absolute py-2 left-0 bg-white w-full rounded-md shadow-2xl top-[0px]">
                      <li
                        className="w-full flex items-center text-left px-6 py-2 text-base hover:bg-gray-5-light"
                        onClick={e => {
                          e.stopPropagation();
                          setAdSpendChild(false);
                        }}
                      >
                        <svg
                          className="mr-[10px] rotate-90 fill-current w-2"
                          width="11"
                          height="16"
                          viewBox="0 0 11 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.11567 10.5391C5.31557 10.7789 5.68399 10.7789 5.88389 10.5391L9.81637 5.82009C10.0878 5.49442 9.85618 5 9.43226 5H1.5673C1.14338 5 0.911804 5.49442 1.18319 5.82009L5.11567 10.5391Z"
                          />
                        </svg>

                        {t('Return')}
                      </li>
                      {key?.subAdSpend?.map((key, index) => {
                        return (
                          <li
                            key={index}
                            className="w-full text-left px-6 py-2 text-base hover:bg-gray-5-light"
                            onClick={() => {
                              setAdSpend({
                                title: key.title,
                                hsID: key.hsID,
                              });
                              setAdSpendChild(false);
                            }}
                          >
                            {key.title}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </>
              ))}
          </ul>
        )}
      </Button>
    </div>
  );
};

export default AdSpendInput;
